import { prepareImageUpload } from './imageUpload.js';
import { prepareVideoUpload } from './videoUpload.js';

export const MAX_EVIDENCE_BYTES = 10 * 1024 * 1024;

export async function prepareEvidenceUpload(file) {
  return file?.type === 'video/mp4' ? prepareVideoUpload(file) : prepareImageUpload(file);
}

export async function prepareAndValidateEvidenceUpload(file) {
  const prepared = await prepareEvidenceUpload(file);
  if (!prepared.size || prepared.size > MAX_EVIDENCE_BYTES) {
    const kind = prepared.type === 'video/mp4' ? 'Video' : prepared.type.startsWith('image/') ? 'Foto' : 'Dokument';
    throw new Error(`Das ${kind} darf maximal 10 MB groß sein.`);
  }
  return prepared;
}
